<template>
    <div class="admin-operations-main-body">
        <admin-operation operation-name="create_tenant" />
        <admin-operation operation-name="update_tenant" />
        <admin-operation operation-name="create_user" />
        <admin-operation operation-name="update_user" />
        <admin-operation operation-name="create_connector" />
        <admin-operation operation-name="update_connector" />
    </div>
</template>

<script>
import AdminOperation from './AdminOperation'
export default {
    name: 'AdminOperationsMainBody',
    components: {
        AdminOperation
    }
}
</script>

<style lang="scss" scoped>
.admin-operations-main-body {
    width: 100%;
    display: inline-grid;
    grid-template-columns: auto auto auto;
    gap: 4rem;
    padding: 5rem 12.5rem;
    justify-content: center;
}
</style>
